import { render, staticRenderFns } from "./add-update.vue?vue&type=template&id=54d223bf&scoped=true"
import script from "./add-update.vue?vue&type=script&lang=js"
export * from "./add-update.vue?vue&type=script&lang=js"
import style0 from "./add-update.vue?vue&type=style&index=0&id=54d223bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d223bf",
  null
  
)

export default component.exports